import { ApiPromotion } from 'idt-ecommerce-api/_api/api-promotions/models/api-promotion.models';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { Promotion } from 'idt-ecommerce-api/promotions/promotions.model';
import { MoneyHelpers } from 'idt-ecommerce-api/util/money.helpers';


export class PromotionTransformer {

  public static getPromotionsFromApi(promotions: ApiPromotion[], context: EcommerceContext): Promotion[] {
    return promotions.map((promotion) => PromotionTransformer.getPromotionFromApi(promotion, context));
  }

  public static getPromotionFromApi(promotion: ApiPromotion, context: EcommerceContext): Promotion {
    const currencyInfo = context?.store?.details?.currencyInfo;

    return {
      name: promotion.name,
      shippingMethods: promotion.metodosEnvio.map(
        (metodoEnvio: (string | null)[]) => metodoEnvio[0]
      ),
      priceMinWithSymbol: promotion.precioMinimo && promotion.precioMinimo[0] && isDefined(currencyInfo)
        ? MoneyHelpers.formatPriceWithCurrencySymbol(promotion.precioMinimo[0], currencyInfo)
        : '',
      shippingDiscountoWhitSymbol: promotion.descuentosEnvio && isDefined(currencyInfo)
        ? MoneyHelpers.formatPriceWithCurrencySymbol(promotion.descuentosEnvio[0], currencyInfo)
        : '',
      startDate: promotion.startDate,
      endDate: promotion.endDate,
      shortDesc: promotion.shortDesc
    };
  }

}
